// switch (window.location.hostname) {
//   case 'web.better-me.ca':
//     module.exports = require('./api-prod');
//     break;
//   default:
//     module.exports = require('./api-dev');
// }

export const baseUrl = 'https://betterapp.azurewebsites.net/api';
